import { memo } from 'react';

import { Typography } from 'antd';

import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import { CHECKOUT_ELEMENTS_URL, CHECKOUT_SUN_URL } from 'settings';

interface IProps {
  productId: number | string;
  copiedCheckout: () => void;
  className?: string;
}

const ShareableLinks = ({ productId, copiedCheckout }: IProps) => {
  return (
    <div className='flex flex-col gap-2 p-2'>
      <div>
        <Typography.Text className='text-content-subtitle mb-1 block font-medium'>
          Eduzz Checkout Elements
        </Typography.Text>
        <CustomCopyToClipboard
          text={`${CHECKOUT_ELEMENTS_URL}/${productId}`}
          disableUnderline
          fullWidth
          onCopy={copiedCheckout}
        />
      </div>
      <div>
        <Typography.Text className='text-content-subtitle mb-1 block font-medium'>Eduzz Checkout</Typography.Text>
        <CustomCopyToClipboard
          text={`${CHECKOUT_SUN_URL}/${productId}`}
          disableUnderline
          fullWidth
          onCopy={copiedCheckout}
        />
      </div>
    </div>
  );
};

export default memo(ShareableLinks);
